import { render, staticRenderFns } from "./imgA.vue?vue&type=template&id=76eb19da&scoped=true"
var script = {}
import style0 from "./imgA.vue?vue&type=style&index=0&id=76eb19da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eb19da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76eb19da')) {
      api.createRecord('76eb19da', component.options)
    } else {
      api.reload('76eb19da', component.options)
    }
    module.hot.accept("./imgA.vue?vue&type=template&id=76eb19da&scoped=true", function () {
      api.rerender('76eb19da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgA.vue"
export default component.exports